$(() => {
  const $fixedPlanSearchButton = $('.fixed-plan-search-button')
  const $modalPlanSearch = $('.modal-plan-search')
  const $modalClose = $modalPlanSearch.find('.btn-close')

  $fixedPlanSearchButton.on('click', function(e) {
    e.preventDefault()
    $modalPlanSearch.toggleClass('active')
    $('body').toggleClass('backdrop')
  })

  $modalClose.on('click', function(e) {
    e.preventDefault()
    $modalPlanSearch.toggleClass('active')
    $('body').toggleClass('backdrop')
  })
})